export default "__VITE_ASSET__JIkPF9Hr__"